export const AI_CHAT_CONVERSATIONS_CALL = 'AI_CHAT_CONVERSATIONS_CALL';
export const AI_CHAT_MESSAGES_CALL = 'AI_CHAT_MESSAGES_CALL';
export const AI_CHAT_SEND_PROMPT_CALL = 'AI_CHAT_SEND_PROMPT_CALL';

export function callAiConversations() {
    return { type: AI_CHAT_CONVERSATIONS_CALL };
}

export function callAiMessages(conversationId) {
    return { type: AI_CHAT_MESSAGES_CALL, payload: { conversationId } };
}

export function callSendAiPrompt({ prompt, conversationId, localMessageId, files }) {
    return {
        type: AI_CHAT_SEND_PROMPT_CALL,
        payload: {
            prompt,
            conversationId: conversationId || null,
            localMessageId: localMessageId || `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
            files: files || []
        }
    };
}
